import { createApiSlice } from "@common";
import {
  CURD_CUSTOMERS_TYPE
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addCustomerType",
    method: "post",
    url: CURD_CUSTOMERS_TYPE,
    stateKey: "message",
  },
  {
    name: "getCustomerType",
    method: "get",
    url: CURD_CUSTOMERS_TYPE,
    stateKey: "data",
  },
  {
    name: "updateCustomerType",
    method: "put",
    url: CURD_CUSTOMERS_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteCustomerType",
    method: "delete",
    url: CURD_CUSTOMERS_TYPE,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "customerType",
  apiConfig,
  customReducers,
);
const customerTypeSlice = slice;
// Export the slice's reducer
export default customerTypeSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addCustomerType,
  getCustomerType,
  updateCustomerType,
  deleteCustomerType
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
